module.exports = __webpack_public_path__ + "static/media/icon-heart-inactive@2x.319a98d2.png";